import { render } from "./InvoiceDetailTabDetail.vue?vue&type=template&id=a348a10e&scoped=true"
import script from "./InvoiceDetailTabDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailTabDetail.vue?vue&type=script&lang=js"

import "./InvoiceDetailTabDetail.vue?vue&type=style&index=0&id=a348a10e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a348a10e"]])

export default __exports__